module.exports = __webpack_public_path__ + "img/FR19530.426ba12f.png";